(function() {
  function loadRegions(root) {
    root.querySelectorAll('[data-wine-region-links]').forEach(function(nav) {
      if (nav.dataset.initialized) return;
      nav.dataset.initialized = 'true';
      // Shopify exposes the full facet values only in a collection-page context.
      fetch(nav.dataset.regionSource, { credentials: 'same-origin' })
        .then(function(response) {
          if (!response.ok) throw new Error('Region links unavailable');
          return response.text();
        })
        .then(function(html) {
          var result = new DOMParser().parseFromString(html, 'text/html');
          nav.querySelectorAll('[data-wine-region]').forEach(function(link) {
            var updated = Array.from(result.querySelectorAll('[data-wine-region]')).find(function(candidate) {
              return candidate.dataset.wineRegion === link.dataset.wineRegion;
            });
            if (updated) link.setAttribute('href', updated.getAttribute('href'));
          });
          nav.dataset.loaded = 'true';
        })
        .catch(function() {
          // Keep the server-rendered broader-region links usable on a failed request.
          nav.dataset.loaded = 'error';
        });
    });
  }
  loadRegions(document);
  document.addEventListener('shopify:section:load', function(event) {
    loadRegions(event.target);
  });
}());
